<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        <p>世界百科课 评价详情</p>
      </div>
      <div class="right"></div>
    </div>
    <div>
      <el-form :inline="true" :model="queryParams" label-width="70px">
        <el-form-item label="">
            <el-select
              v-model="queryParams.star"
              clearable
              placeholder="选择星级"
              class="label"
            >
              <el-option
                v-for="item in starList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入评价人姓名"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker 
				   	v-model="queryParams.time"
				   	type="daterange"
				   	style="width: 240px;"
				   	range-separator="-"
				   	start-placeholder="开始日期"
				   	end-placeholder="结束日期"
				   	:picker-options="pickerOptions">
				  </el-date-picker>
        </el-form-item>
        
        <el-form-item label="" style="margin-left: 20px">
          <el-button type="primary" size="small" @click="searchFun()"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>

      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="a" label="评价人" align="center">
          </el-table-column>
          <el-table-column prop="c" label="身份" align="center">
          </el-table-column>
          <el-table-column prop="d" label="班级" align="center">
          </el-table-column>
          <el-table-column prop="d" label="账号" align="center">
          </el-table-column>
          <el-table-column
            prop="e"
            label="评价星级"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="f" label="评价内容" align="center">
          </el-table-column>
          <el-table-column prop="b" label="评价时间" align="center">
          </el-table-column>
          <el-table-column prop="g" label="评价时间" align="center">
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="200"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="del(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import dayjs from "dayjs";
export default {
  props: ["info"],
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
        date: "",
        startDate:'',
        endDate:'',
        star:'',
      },
      starList: [
        {id:'star1',label:'1星'},
        {id:'star2',label:'2星'},
        {id:'star3',label:'3星'},
        {id:'star4',label:'4星'},
        {id:'star5',label:'5星'},
      ],
      tableData: [
        {a:"莫莎静",b:"2021/12/1 20:46:44",c:"学生",d:"三年级2班",e:"5星",f:"很好很好很好很好很好很好",g:"hyj***7rtg"},
        {a:"裴君静",b:"2021/12/1 20:46:44",c:"家长",d:"四年级3班",e:"4星",f:"我觉得比较一般",g:"hyj***7rtg"},
        {a:"陆秋叶",b:"2021/12/1 20:46:44",c:"学生",d:"三年级2班",e:"3星",f:"还行吧",g:"hyj***7rtg"},
        {a:"宁颖姬",b:"2021/12/1 20:46:44",c:"家长",d:"四年级3班",e:"5星",f:"我觉得比较一般",g:"hyj***7rtg"},
        {a:"仇云瑗",b:"2021/12/1 20:46:44",c:"学生",d:"三年级2班",e:"2星",f:"这个课程的新颖模式，科学的思维方法，对孩子是一个很好的启蒙！",g:"hyj***7rtg"},
        {a:"傅秋菲",b:"2021/12/1 20:46:44",c:"家长",d:"四年级3班",e:"5星",f:"不满意老师",g:"hyj***7rtg"},
        {a:"叶马蕊",b:"2021/12/1 20:46:44",c:"学生",d:"三年级2班",e:"3星",f:"学不会",g:"hyj***7rtg"},
      ],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  watch: {
    "info.classId": function (n, o) {
      this.pageNum = 1;
      // this.getDataList();
    },
  },
  created() {},
  methods: {
    async getDataList() {
      let start = "",
        end = "";
      if (this.queryParams.date) {
        start = this.queryParams.startDate;
        end = this.queryParams.endDate;
      }
      let params = {
        schoolYearSemester: this.queryParams.semester,
        startDate: start,
        endDate: end,
        studentName: this.queryParams.name,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        classId: this.info.classId,
        page: this.pageNum,
        limit: this.pageSize,
      };
      this.tableData=[]
      // let res = await api.handleStudentAttendanceDetails(params);
      // if (res.code === "0") {
      //   this.tableData = res.data?.list || [];
      //   this.totalPage = res.data?.total || 0;
      // }
      // console.log('课程评价-查看详情',res)
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;

      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toIndex() {
      this.$emit("to-index");
    },
    // 自定义时间过滤
    customTimeSure() {
      let that = this.queryParams;
      if (that.date) {
        that.startDate = dayjs(that.date)
          .startOf("week")
          .format("YYYY-MM-DD");
        that.endDate = dayjs(that.date)
          .endOf("week")
          .format("YYYY-MM-DD");
      }
    },
    del(item){

    },
  },
  mounted() {
    // this.semesterList = this.semesterArr.map((v) => ({
    //   label: v.schoolYear + "第" + v.semester + "学期",
    //   id: v.schoolYear + "_" + v.semester,
    // }));
  },
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
      line-height: 30px;
      width: 200px;
      text-align: center;
      margin-top: 10px;
      .text{
        height: 18px;
        line-height: 16px;
        font-size: 16px;
        color: #888;
        margin-top: 5px;
        padding-left: 5px;
      }
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
